import React, { useEffect, useRef, useState } from "react";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import Seo from "../components/Seo";

const ComplaintForm = () => {
    const [loading, setLoading] = useState(true);
  const iframeRef = useRef(null);

  useEffect(() => {
    const handleMessage = (event) => {
      if (typeof event.data === "string") {
        const data = event.data.split("|");

        if (data.length >= 2) {
          const newHeight = parseInt(data[1], 10) + 15 + "px";

          if (iframeRef.current) {
            iframeRef.current.style.height = newHeight;
          }
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);
    
    

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Seo
        title="Submit a Complaint"
        description="Have an issue with a WayaQuick payment or service? Submit a complaint and our support team will follow up."
      />
      {/* Page has no visible heading; this H1 is for search engines and screen readers only */}
      <h1 className="sr-only">Submit a Complaint</h1>
      
      {/* Skeleton Loader */}
      {loading && (
        <Box sx={{ padding: 3 }}>
          <Skeleton variant="text" height={40} width="60%" />
          <Skeleton variant="text" height={30} width="40%" />
          <Skeleton variant="rectangular" height={100} sx={{ mt: 2 }} />
          <Skeleton variant="rectangular" height={100} sx={{ mt: 2 }} />
          <Skeleton variant="rectangular" height={100} sx={{ mt: 2 }} />
          <Skeleton variant="rectangular" height={100} sx={{ mt: 2 }} />
          <Skeleton variant="rectangular" height={60} sx={{ mt: 2 }} />
        </Box>
      )}
      
      <iframe
        ref={iframeRef}
        title="Submit a Complaint"
        src="https://forms.zohopublic.com/wayabank/form/ComplaintTicketingForm/formperma/ut_-h9uwYeIcgRv0goP-ZanRBHFZwWP9_udhzLdUUKI?zf_rszfm=1"
        style={{
          border: "none",
          width: "100%",
          height: "1000px",
        }}
        onLoad={() => setLoading(false)}
      />
    </Box>
  );
};

export default ComplaintForm;